import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert, { AlertColor, AlertProps } from '@mui/material/Alert';
import { useAppDispatch, useAppSelector } from '../../redux_store/reduxStore';
import { hideSnackbar, snackbarState } from '../../redux_store/slices/snackbarSlice';
import React from 'react';
import _ from 'lodash';

export interface BakeasySnackbarReduxProp {
  open?: boolean;
  message?: string | any;
  severity?: AlertColor;
  handleOnClose?: (event: React.SyntheticEvent | Event) => void;
}

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function BakeasySnackbarRedux() {
  const dispatch = useAppDispatch();
  const { message, open, severity } = useAppSelector(snackbarState);

  function handleOnClose() {
    dispatch(hideSnackbar());
  }

  return (
    <Stack spacing={2} sx={{ width: '100%' }}>
      {open && (
        <Snackbar
          open={open ?? false}
          autoHideDuration={2000}
          onClose={handleOnClose}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
          <Alert onClose={handleOnClose} severity={severity} sx={{ width: '100%' }}>
            {_.isEmpty(message) ? 'Response : {}' : message}
          </Alert>
        </Snackbar>
      )}
    </Stack>
  );
}

export default BakeasySnackbarRedux;
